const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

function getDays( milliseconds ) {
	return Math.floor( milliseconds / DAY );
}

function getHours( milliseconds ) {
	return Math.floor( milliseconds / HOUR );
}

function getMinutes( milliseconds ) {
	return Math.floor( milliseconds / MINUTE );
}

function getSeconds( milliseconds ) {
	return Math.floor( milliseconds / SECOND );
}

function getSuffix( timeAmount, shortTimeType, shortSuffix ) {
	const typeMap = {
		d: "day",
		h: "hour",
		m: "minute",
		s: "second"
	};

	if ( shortSuffix ) {
		return shortTimeType;
	} else if ( typeMap.hasOwnProperty( shortTimeType ) ) {
		return ` ${typeMap[shortTimeType]}${timeAmount === 1 ? "" : "s"}`;
	}
}

function getTimeStr( milliseconds, includeSeconds, shortSuffix, levels ) {
	const timeArr = [];
	let remainingMs = milliseconds;

	const days = getDays( remainingMs );

	remainingMs -= days * DAY;

	const hours = getHours( remainingMs );

	remainingMs -= hours * HOUR;

	const minutes = getMinutes( remainingMs );

	remainingMs -= minutes * MINUTE;

	const seconds = getSeconds( remainingMs );

	remainingMs -= seconds * SECOND;

	if ( days ) {
		timeArr.push( `${days}${getSuffix( days, "d", shortSuffix )}` );
	}

	if ( hours ) {
		timeArr.push( `${hours}${getSuffix( hours, "h", shortSuffix )}` );
	}

	if ( minutes ) {
		timeArr.push( `${minutes}${getSuffix( minutes, "m", shortSuffix )}` );
	}

	if ( includeSeconds ) {
		timeArr.push( `${seconds}${getSuffix( seconds, "s", shortSuffix )}` );
	}

	// Get two highest time intervals, then join them
	return timeArr.slice( 0, levels ).join( " " );
}


export default function( milliseconds, includeSeconds = true, shortSuffix = true, levels = 2 ) {
	return getTimeStr( milliseconds, includeSeconds, shortSuffix, levels );
}
